import { z } from "zod";

export const immunizationFormSchema = z.object({
  dateAdministered: z
    .date()
    .min(
      new Date("1900-01-01"),
      "Administration date must be greater than or equal to 1900-01-01",
    )
    .max(new Date(), "Administration date must be less than or equal to today"),
  vaccineCode: z.string().min(1, "Vaccine code is required"),
  vaccineDisplay: z.string().min(1, "Vaccine display is required"),
  vaccineSystem: z.string().min(1, "Vaccine system is required"),
});
